var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-box"},[_c('div',{staticClass:"title"},[_vm._v("每日血糖曲线")]),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.dayLoading),expression:"dayLoading"}],staticStyle:{"width":"100%","height":"24rem"},attrs:{"id":"todaysugar"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }